<template>
  <div class="padded vh100 flex-center">
    <form id="login-view" class="card form form_login padded-xl w500" @submit.prevent="dologin">
      <div>
        <img src="favicon.png" alt="" style="height: 40px; margin-bottom: 15px;"/>
      </div>
      <h1 class="display-7 mb-4">Login</h1>
      <transition name="fade">
        <alert-bar v-if="msgtext" v-bind:class="msgclass">{{msgtext}}</alert-bar>
      </transition>
      <input-default label="Username" description="Dit is je e-mailadres" v-model="username" capitalizeNone="none"/>
      <input-default label="Password" v-model="password" type="password"/>
      <div class="button-row">
        <button class="btn btn-primary" type="submit" :disabled="loggingin" >Login</button>
        <loader v-if="loading"/>
        <a class="btn btn-link" href="/forgot-password">Wachtwoord vergeten?</a>
      </div>
    </form>
  </div>
</template>

<script>
  import InputDefault from '../components/form/InputDefault.vue';
  import AlertBar from '../components/form/Alert.vue';
  import Loader from '../components/ui/Loader.vue';

  import { userService } from '../services/user.service.js';

  export default {
    props:{
      creatoreditor: {
        type: Boolean
      },
      loginwebsiteid: {
        type: String
      }
    },
    data: function (){
      return {
        msgtext: '',
        msgclass: 'error',
        username: '',
        password: '',
        submitted: false,
        loading: false,
        loggingin: false,
        returnUrl: '',
        returnUrlParts: '',
        error: ''
      }
    },
    created () {
      // reset login status
      userService.logout();

      // get return url from route parameters or default to '/'
      this.returnUrl = this.$route.query.returnUrl || '/';
      this.returnUrlParts = this.returnUrl.split( '/' );
      if (this.returnUrlParts[1] == "creator"){    
        this.loginwebsiteid = this.returnUrlParts[2];
      }
    },
    components: {
      InputDefault,
      AlertBar,
      Loader
    },
    methods: {
      dologin: function (event) {
        this.msgtext = ''; // reset msg text
        if (!this.username) {
          this.msgtext = 'username can\'t be empty!';
          this.msgclass = 'error';
          return;
        }

        if (!this.password) {
          this.msgtext = 'password can\'t be empty!';
          this.msgclass = 'error';
          return;
        }

        userService.login(this.username, this.password)
        .then(
          user => {
            console.log(user)
            this.loading = false;
            if(user.websiteid.length = 1){
              window.location.href = '/user';
            } else {
              alert('you have more websites');
            }
          },
          error => {
            this.msgtext = error;
            this.msgclass = 'error';
            this.loading = false;
          }
        );
      }
    }
  }
</script>
